var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.014 42.889L38.461 38.113C37.56 37.662 37 36.756 37 35.748V32.367C37.229 32.087 37.47 31.768 37.719 31.416C38.958 29.666 39.951 27.718 40.673 25.617C42.084 24.97 43 23.575 43 22V18C43 17.037 42.64 16.104 42 15.375V10.056C42.056 9.506 42.276 6.232 39.908 3.531C37.854 1.188 34.521 0 30 0C25.479 0 22.146 1.188 20.092 3.53C17.724 6.231 17.944 9.506 18 10.056V15.375C17.36 16.104 17 17.037 17 18V22C17 23.217 17.553 24.352 18.497 25.109C19.413 28.736 21.33 31.469 22 32.346V35.655C22 36.623 21.472 37.511 20.623 37.975L11.702 42.841C8.801 44.424 7 47.458 7 50.762V54C7 58.746 22.045 60 30 60C37.955 60 53 58.746 53 54V50.957C53 47.519 51.089 44.427 48.014 42.889Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.4e2eef8500ed5c8f1ebff87fd8718d2f.svg";
export { ForwardRef as ReactComponent };